/**
 * Configuration file for Topup History component
 * Contains table columns, filter options, and other component configurations
 */

const BASE_TH_STYLE = {
  textTransform: 'capitalize',
  fontSize: '14px',
  color: 'black',
  minWidth: '120px',
  textAlign: 'left',
  fontWeight: 400,
}

/**
 * Table column configuration for topup history
 */
export const columnConfig = [
  {
    key: 'numb',
    label: 'No',
    thStyle: { ...BASE_TH_STYLE, minWidth: '25px', width: '25px' },
    thClass: '!pr-[.75rem]',
    tdClass: '!pr-[.75rem]',
  },
  {
    key: 'created_at',
    label: 'Waktu Transaksi',
    thStyle: { ...BASE_TH_STYLE },
  },
  {
    key: 'account_number',
    label: 'Nomor Virtual Account',
    thStyle: { ...BASE_TH_STYLE },
  },
  {
    key: 'transfer_type',
    label: 'Jenis Transfer',
    thStyle: { ...BASE_TH_STYLE, minWidth: '180px' },
  },
  {
    key: 'amount',
    label: 'Nominal Top Up',
    thStyle: { ...BASE_TH_STYLE },
  },
  {
    key: 'status',
    label: 'Status',
    thStyle: { ...BASE_TH_STYLE },
    tdStyle: {
      textTransform: 'capitalize',
      minWidth: '120px',
      textAlign: 'center',
    },
  },
]
/**
 * Status styling configuration
 */
export const statusStyles = {
  PENDING: {
    class: 'bg-[#FFF4ED] text-[#F95E16]',
    text: 'Diproses',
  },
  COMPLETED: {
    class: 'bg-[#F0FDF4] text-[#22C55E]',
    text: 'Berhasil',
  },
  FAILED: {
    class: 'bg-[#FEF2F2] text-[#DC2626]',
    text: 'Gagal',
  },
}
